export const joinUrlSegments = (...segments) => {
  return segments
    .map((segment) => {
      let fsegment = segment;
      if (segment.startsWith('/')) {
        fsegment = fsegment.slice(1);
      }
      if (segment.endsWith('/')) {
        fsegment = fsegment.slice(0, -1);
      }
      return fsegment;
    })
    .join('/');
};
